import { render, staticRenderFns } from "./SectionImg.vue?vue&type=template&id=529dfdeb&scoped=true&"
import script from "./SectionImg.vue?vue&type=script&lang=js&"
export * from "./SectionImg.vue?vue&type=script&lang=js&"
import style0 from "./SectionImg.vue?vue&type=style&index=0&id=529dfdeb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529dfdeb",
  null
  
)

export default component.exports